export class Material {
  constructor({
    id = null,
    matCode = '',
    matName = '',
    matType = '',
    matModel = '',
    matSpec = '',
    matUnit = '',

  } = {}) {

    this.id = id;
    this.matCode = matCode;
    this.matName = matName;
    this.matType = matType;
    this.matModel = matModel;
    this.matSpec = matSpec;
    this.matUnit = matUnit;
  }
}


export function gridFields() {
  return Object.freeze([{
    key: 'matCode',
    label: 'tlt.material.matCode',
    sortable: true,
    form: {
      type: 'input'
    }
  },
  {
    key: 'matName',
    label: 'tlt.material.matName',
    sortable: true,
    form: {
      type: 'input'
    }
  },
  {
    key: 'matType',
    label: 'tlt.material.type',
    sortable: true,
    form: {
      type: 'select',
      options: [
        { value: null, text: '' },
        { value: 'B', text: '大宗物料' },
        { value: 'E', text: '能源' },
      ]
    }
  },
  {
    key: 'matModel',
    label: 'lbl.material.matModel',
    sortable: true,
    form: {
      type: 'input'
    }
  },
  {
    key: 'matSpec',
    label: 'lbl.material.matSpec',
    sortable: true,
    form: {
      type: 'input'
    }
  },
  {
    key: 'matUnit',
    label: 'lbl.material.unit',
    sortable: true,
    form: {
      type: 'input'
    }
  },
  ]);
}

export const fields = Object.freeze(Object.keys(new Material()).map(i => 'entity.' + i));

export const filterFields = [
  'filter.matCodeFilter',
  'filter.matNameFilter',
  'filter.matTypeFilter',

];

export const filter = {
  'matCodeFilter': "",
  'matNameFilter': "",
  'matTypeFilter': "",

};